<template>
  <div class="calendar-toolbar">
    <template v-if="timeRange=='month'">
      <div class="left" />
      <div class="center">
        <div
          class="arrow-btn icon-chevron-back"
          @click="$_goPreviousMonth()"
        />
        <div class="calendar-toobar-title">
          {{ _monthRangeTitle }}
        </div>
        <div
          class="arrow-btn icon-chevron-forward"
          @click="$_goNextMonth()"
        />
      </div>
      <div class="right">
        <div
          class="calendar-gradient-btn"
          :class="{disabled:$_checkSameDay(dateMoment,_todayMoment)}"
          @click="$_goToday()"
        >
          <p>{{ $_getTodayText() }}</p>
        </div>
      </div>
    </template>
    <template v-else-if="timeRange=='year'">
      <div class="left" />
      <div class="center">
        <div
          class="arrow-btn icon-chevron-back"
          @click="$_goPreviousYear()"
        />
        <div class="calendar-toobar-title">
          {{ _yearRangeTitle }}
        </div>
        <div
          class="arrow-btn icon-chevron-forward"
          @click="$_goNextYear()"
        />
      </div>
      <div class="right">
        <div
          class="calendar-gradient-btn"
          :class="{disabled:$_checkSameDay(dateMoment,_todayMoment)}"
          @click="$_goToday()"
        >
          <p>{{ $_getNowYearText() }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    timeRange: {
      type: String,
      default: "month",
    },
    dateMoment: {},
  },
  data: () => ({
    dayFormat: "YYYY-MM-DD",
  }),
  computed: {
    _yearRangeTitle() {
      return this.dateMoment.format("YYYY");
    },
    _monthRangeTitle() {
      return this.dateMoment.format('YYYY-MM');
    },
    _todayMoment() {
      return moment();
    },
  },
  methods: {
    $_goPreviousYear() {
      const previousYearMoment = moment(this.dateMoment).add(-1, "year");
      this.$emit("date-change", previousYearMoment);
    },
    $_goNextYear() {
      const nextYearMoment = moment(this.dateMoment).add(1, "year");
      this.$emit("date-change", nextYearMoment);
    },
    $_goPreviousMonth() {
      const previousMonthMoment = moment(this.dateMoment).add(-1, "month");
      this.$emit("date-change", previousMonthMoment);
    },
    $_goNextMonth() {
      const nextMonthMoment = moment(this.dateMoment).add(1, "month");
      this.$emit("date-change", nextMonthMoment);
    },
    $_goToday() {
      this.$emit("date-change", this._todayMoment);
    },
    $_checkSameDay(momentA, momentB) {
      if (momentA.format(this.dayFormat) == momentB.format(this.dayFormat)) {
        return true;
      } else {
        return false;
      }
    },
    $_getNowYearText() {
      return this.$t("今年");
    },
    $_getTodayText() {
      return this.$t("今天");
    },
  },
};
</script>

<style>
</style>